import React from 'react';
import SectionHeading from '../common/SectionHeading'; // Path to your new heading component
import { ShieldCheck, Clock, Globe } from 'lucide-react'; // Modern icons

const AboutSection = () => {
    const featureClass = `p-2 rounded-lg bg-brand-50 text-brand-500 gh:bg-brand-500 gh:text-white transition-colors`;
    return (
        <section className="md:py-20 py-10 px-5 overflow-hidden bg-white">
            <div className="container mx-auto px-4">
                <div className="flex flex-col lg:flex-row items-center gap-12 lg:gap-20">
                    
                    {/* Left Side: Image with Decorative Elements */}
                    <div className="relative w-full lg:w-1/2">
                        {/* Decorative Background Square */}
                        <div className="absolute -top-6 -left-6 w-32 h-32 bg-brand-50 rounded-2xl -z-10 animate-pulse"></div>
                        
                        {/* Main Image Container */}
                        <div className="relative">
                            <img 
                                className="  " 
                                src="/assets/images/about-cargo.png" 
                                alt="Blue Dart Express Cargo" 
                            />
                        </div>

                        {/* Floating "Experience" Badge */}
                        <div className="absolute -bottom-6 -right-6 bg-brand-500 text-white p-6 rounded-2xl shadow-xl hidden md:block">
                            <p className="Ethnocentric text-2xl leading-none">24/7</p>
                            <p className="text-[10px] uppercase tracking-widest font-bold opacity-80">Support Available</p>
                        </div>
                    </div>

                    {/* Right Side: Content */}
                    <div className="w-full lg:w-1/2 space-y-6">
                        <SectionHeading 
                            subtitle="About Our Company" 
                            title="Bluedart Express Dubai" 
                        />
                        
                        <p className="text-gray-600 text-lg leading-relaxed first-letter:text-4xl first-letter:font-bold first-letter:text-brand-500 first-letter:mr-1">
                            Blue Dart Express Dubai is leading the shift towards sustainable logistics. 
                            We specialize in eco-friendly shipping solutions that reduce environmental 
                            impact while maximizing efficiency.
                        </p>

                        <p className="text-gray-500 italic border-l-4 border-brand-200 pl-4 py-1">
                            "More than just packages, we deliver emotions — with care, responsibility, 
                            and 24/7 Operational Excellence."
                        </p>

                        {/* Feature List */}
                        <div className="grid grid-cols-1 md:grid-cols-2 gap-4 pt-4">
                            <div className="flex items-center gap-3 group">
                                <div className={featureClass}>
                                    <Globe size={35} />
                                </div>
                                <span className="font-bold text-gray-800 text-md uppercase tracking-tight">Worldwide Delivery</span>
                            </div>
                            <div className="flex items-center gap-3 group">
                                <div className={featureClass}>
                                    <Clock size={35} />
                                </div>
                                <span className="font-bold text-gray-800 text-md uppercase tracking-tight">On Time Everytime</span>
                            </div>
                            <div className="flex items-center gap-3 group">
                                <div className={featureClass}>
                                    <ShieldCheck size={35} />
                                </div>
                                <span className="font-bold text-gray-800 text-md uppercase tracking-tight">Safe & Secure</span>
                            </div>
                        </div>

                        {/* Final Signature Quote/Slogan */}
                        <div className="pt-6">
                            <h5 className="Ethnocentric text-brand-500 text-sm tracking-tighter">
                                Proudly, we deliver The World On Time.
                            </h5>
                        </div>
                    </div>

                </div>
            </div>
        </section>
    );
};

export default AboutSection;